import { useCallback, useEffect, useState } from 'react'
import { useAISubtaskGeneration } from './useAISubtaskGeneration'
import { AISubtaskType, IAIGeneratedSubtask, hasGeneratedContent } from '../model/generation'

interface IOptions {
  getSubtaskType: () => AISubtaskType
  onGenerated: (result: IAIGeneratedSubtask, images: string[], type: AISubtaskType) => void
}

/** Standalone audit presentation; VM generation keeps its existing timing. */
export function useAiAuditGeneration({ getSubtaskType, onGenerated }: IOptions) {
  const [showCompleted, setShowCompleted] = useState(false)
  const handleGenerated = useCallback(
    (result: IAIGeneratedSubtask, images: string[], type: AISubtaskType) => {
      onGenerated(result, images, type)
      if (hasGeneratedContent(result, type)) setShowCompleted(true)
    },
    [onGenerated]
  )
  const generation = useAISubtaskGeneration({ getSubtaskType, onGenerated: handleGenerated })
  const generationComplete = showCompleted && !generation.isGenerating

  useEffect(() => {
    if (!generationComplete) return
    const timer = window.setTimeout(() => setShowCompleted(false), 1500)
    return () => window.clearTimeout(timer)
  }, [generationComplete])

  return {
    ...generation,
    isGenerating: generation.isGenerating || showCompleted,
    generationComplete,
  }
}
